import { BaseStatusDto } from '../baseStatusDto';

export class AuditFormFrequencyDto extends BaseStatusDto {}
